@use "@/styles/variables" as *;

.content {
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.summaryBar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	padding: 8px 10px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	background: #f8fafc;
	color: #334155;
}

.summaryItem {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
}

.summaryItem span {
	font-size: 0.75rem;
	font-weight: 700;
	color: #64748b;
}

.summaryItem strong {
	font-size: 0.86rem;
	color: #1e293b;
	white-space: nowrap;
}

.lines {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.lineRow {
	display: grid;
	grid-template-columns: minmax(190px, 1.15fr) minmax(150px, 0.75fr) minmax(250px, 1.35fr) minmax(170px, 0.85fr);
	gap: 10px;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid $gray-200;
	border-radius: 6px;
	background: #ffffff;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease,
		background-color 0.15s ease;
}

.lineFinished {
	border-color: rgba($primary-color, 0.55);
	background: $primary-bg;
	box-shadow: inset 0 0 0 1px rgba($primary-color, 0.08);
}

.productBlock {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
}

.productBlock strong {
	font-size: 0.94rem;
	color: #0f172a;
}

.productBlock span,
.quantityGrid span,
.availableMessage,
.unavailableMessage {
	font-size: 0.78rem;
	color: #64748b;
}

.quantityGrid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
}

.quantityGrid div {
	display: flex;
	flex-direction: column;
	gap: 3px;
}

.quantityGrid strong {
	font-size: 0.86rem;
	color: #1e293b;
}

.codesBlock {
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
}

.modeToggle {
	display: inline-flex;
	align-self: flex-start;
	padding: 2px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	background: #f8fafc;
}

.modeToggle button {
	height: 26px;
	padding: 0 10px;
	border: none;
	border-radius: 4px;
	background: transparent;
	font-size: 0.74rem;
	font-weight: 600;
	color: #64748b;
	cursor: pointer;
	transition:
		background-color 0.15s ease,
		color 0.15s ease;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
}

.modeToggleActive {
	background: #ffffff !important;
	color: #0f172a !important;
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.suggestedRow {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.manualCodesRow {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
}

.manualCodeField {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.manualCodeField span {
	flex-shrink: 0;
	width: 16px;
	font-size: 0.72rem;
	font-weight: 700;
	color: #94a3b8;
	text-align: right;
}

.manualCodeField input {
	width: 108px;
	height: 30px;
	padding: 0 8px;
	border: 1px solid #cbd5e1;
	border-radius: 6px;
	background: #ffffff;
	font-size: 0.8rem;
	color: #0f172a;

	&:focus {
		outline: none;
		border-color: $primary-color;
		box-shadow: 0 0 0 2px rgba($primary-color, 0.12);
	}

	&:disabled {
		background: #f8fafc;
		color: #94a3b8;
	}
}

.addCodeButton {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	padding: 0;
	border: 1px dashed #cbd5e1;
	border-radius: 6px;
	background: #f8fafc;
	color: #64748b;
	cursor: pointer;

	&:hover:not(:disabled) {
		border-color: $primary-color;
		color: $primary-color;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}

.codePill {
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	padding: 3px 7px;
	border-radius: 6px;
	background: #ecfdf5;
	color: #166534;
	font-size: 0.76rem;
	font-weight: 600;
	white-space: nowrap;
}

.actionBlock {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 6px;
}

.finishedCheck {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-size: 0.79rem;
	font-weight: 700;
	color: $secondary-color;
}

.availableMessage {
	color: $secondary-color;
	text-align: right;
}

.unavailableMessage {
	color: $warning-color;
	text-align: right;
}

.emptyState {
	padding: 24px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	text-align: center;
	color: #64748b;
}

@media (max-width: 1200px) {
	.lineRow {
		grid-template-columns: 1fr;
		align-items: stretch;
	}

	.actionBlock {
		align-items: flex-start;
	}

	.availableMessage,
	.unavailableMessage {
		text-align: left;
	}
}

@media (max-width: 640px) {
	.summaryBar,
	.quantityGrid {
		grid-template-columns: 1fr;
		flex-direction: column;
		align-items: flex-start;
	}
}
